<div class="splash-wrapper" [class.fadeout]="phase === 'fadeout'" *ngIf="isVisible">

  <!-- Ambient glow orbs -->
  <div class="orb orb-1"></div>
  <div class="orb orb-2"></div>
  <div class="orb orb-3"></div>

  <!-- Particle field -->
  <div class="particles">
    <span *ngFor="let p of [1,2,3,4,5,6,7,8,9,10,11,12]" class="particle" [attr.data-i]="p"></span>
  </div>

  <!-- Main content -->
  <div class="splash-content">

    <!-- Logo container -->
    <div
      class="logo-container"
      [class.logo-bounce-in]="phase === 'logo' || phase === 'text'"
      [class.logo-pulse]="phase === 'pulse' || phase === 'fadeout'">

      <!-- Glow ring behind logo -->
      <div class="glow-ring"></div>

      <!-- Logo image -->
      <img
        class="logo-img"
        src="assets/imgs/myFamilyLogo.png"
        alt="Vanshavali Logo"
        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">

      <!-- Fallback SVG icon if logo doesn't load -->
      <div class="logo-fallback" style="display:none">
        <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="20" r="10" fill="#c084fc"/>
          <line x1="40" y1="30" x2="20" y2="55" stroke="#c084fc" stroke-width="2.5"/>
          <line x1="40" y1="30" x2="60" y2="55" stroke="#c084fc" stroke-width="2.5"/>
          <circle cx="20" cy="58" r="8" fill="#818cf8"/>
          <circle cx="60" cy="58" r="8" fill="#818cf8"/>
        </svg>
      </div>
    </div>

    <!-- App name text -->
    <div
      class="app-title"
      [class.title-visible]="phase === 'text' || phase === 'pulse' || phase === 'fadeout'">
      <span class="title-text">Vanshavali</span>
      <span class="title-tagline">Your Family. Your Legacy.</span>
    </div>

    <!-- Loading dots -->
    <div
      class="loading-dots"
      [class.dots-visible]="phase === 'pulse' || phase === 'text'">
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>

  <!-- Bottom gradient line -->
  <div class="bottom-gradient-line"></div>

</div>
